import { Dropdown } from 'antd'
import Flex from 'components/Flex'
import SearchInput from 'components/SearchInput'
import ArrowLeftClick from 'components/icons/ArrowLeftClick'
import ArrowRightClick from 'components/icons/ArrowRightClick'
import CalendarIcon from 'components/icons/CalendarIcon'
import CheckListIcon from 'components/icons/CheckListIcon'
import { format, subDays } from 'date-fns'
import React from 'react'
import { COLORS } from 'theme'
import TreeSelect from '../../../components/TreeSelect'
import {
  CommonToggle,
  RightSticky,
  ToggleContainer,
} from '../Partials/EventDetails/Style'
import {
  Container,
  DateClickText,
  LeftSection,
  SectionName,
  TopHeading,
  StyledSpan
} from './style'

const filterByCategoryBasedOption = [
  {
    value: 'showAll',
    title: 'Show All',
    children: [
      { value: 'PRE_PLACEMENT_TALK', title: 'Pre Placement Talk' },
      { value: 'SEMINAR', title: 'Seminar' },
      { value: 'WEBINAR', title: 'Webinar' },
      { value: 'LECTURE', title: 'Lecture' },
      { value: 'WORKSHOP', title: 'Workshop' },
      { value: 'CONFERENCE', title: 'Conference' },
      { value: 'PANEL_DISCUSSION', title: 'Panel Discussion' },
      { value: 'HACKATHON', title: 'Hackathon' },
      { value: 'CAMPAIGN', title: 'Campaign' },
      { value: 'SPORTS_EVENT', title: 'Sports Event' },
      { value: 'ACTIVITY_EVENT', title: 'Activity / Event' },
      { value: 'EXHIBITION', title: 'Exhibition' },
      { value: 'OTHERS', title: 'Others' },
    ],
  },
]

const Header = ({
  handlePrevWeek,
  toggleMiniCalendar,
  menu,
  showMiniCalendar,
  formattedListDate,
  handleNextWeek,
  currentWeekStart,
  currentWeekEnd,
  handleCategoryChange,
  selectedCategory,
  handleToggleChange,
  handleSearch,
  state,
}) => {
  return (
    <>
      <Container spaceBetween>
        <LeftSection centerVertically>
          <SectionName column>
            <TopHeading>Events</TopHeading>
            <Flex
              row
              style={{
                width: '100%',
                position: 'relative',
                gap: '0.5rem',
                alignItems: 'center',
              }}
              id="calendardetails"
            >
              <StyledSpan onClick={() => {handlePrevWeek()}}>
                <ArrowLeftClick />
              </StyledSpan>
              <Dropdown
                onClick={toggleMiniCalendar}
                trigger={['click']}
                overlay={menu}
                visible={showMiniCalendar}
                getPopupContainer={() =>
                  document.getElementById('calendardetails')
                }
              >
                <span>
                  <DateClickText>
                    {state.currentToggle == 'left'
                      ? formattedListDate
                      : format(subDays(currentWeekStart, 1), 'd MMM') +
                        '—' +
                        format(subDays(currentWeekEnd, 1), 'd MMM, yyyy')}
                  </DateClickText>
                </span>
              </Dropdown>
              <StyledSpan onClick={() => {handleNextWeek()}} >
                <ArrowRightClick />
              </StyledSpan>
            </Flex>
          </SectionName>
        </LeftSection>
        <RightSticky>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '1rem',
            }}
          >
            <div>Event cat.</div>

            <TreeSelect
              showArrow={true}
              filterTreeNode={false}
              treeData={filterByCategoryBasedOption || []}
              treeCheckable={true}
              maxTagCount={0}
              placeholder="Select Category"
              showSearch={false}
              onChange={handleCategoryChange}
              showCheckedStrategy={'SHOW_PARENT'}
              placeholderSize={'12px'}
              labelInValue
              shadowBox
              treeDefaultExpandAll={true}
              removeTreeIndent={true}
              height={'auto'}
              treeNodeFilterProp="title"
              autoClearSearchValue={false}
              style={{ width: '230px' }}
              value={selectedCategory}
              removeIndent={true}
            />
          </div>
          <ToggleContainer>
            <CommonToggle
              background={
                state.currentToggle === 'left' ? COLORS.PRIMARY : COLORS.WHITE
              }
              onClick={() => handleToggleChange('left')}
            >
              <CheckListIcon
                width="20"
                height="21"
                color={
                  state.currentToggle === 'left'
                    ? COLORS.PRIMARY
                    : COLORS.GREY_T_80
                }
              />
            </CommonToggle>
            <CommonToggle
              background={
                state.currentToggle === 'right' ? COLORS.PRIMARY : COLORS.WHITE
              }
              onClick={() => handleToggleChange('right')}
            >
              <CalendarIcon
                width="20"
                height="21"
                color={
                  state.currentToggle === 'right'
                    ? COLORS.WHITE
                    : COLORS.GREY_T_80
                }
              />
            </CommonToggle>
          </ToggleContainer>
        </RightSticky>
      </Container>
      <div style={{ marginLeft: 10, marginRight: 10, marginTop: 15 }}>
        <SearchInput
          placeholder="Search by keyword"
          width="100%"
          height="42px"
          background="white"
          setSearchValue={value => handleSearch(value)}
          searchValue={state.search || ''}
          iconPosition={'prefix'}
          borderLess={true}
        />
      </div>
    </>
  )
}

export default Header
